import { jsx as _jsx } from "react/jsx-runtime";
import Responsive from 'react-responsive';
import styled from 'styled-components';
import { Sizes } from '../../theme/Media';
import { useTableContext } from './context';
import Td, { Wrapper as TdWrapper } from './Td';
import Tr from './Tr';
export const Separator = styled.tbody `
  &:first-child,
  &:last-child {
    display: none;
  }
  ${TdWrapper} {
    padding: 3px 0;
  }
  & + & {
    ${TdWrapper} {
      padding: 2px 0;
    }
  }
`;
const TbodySeparator = () => {
    const { isCollapsedNav } = useTableContext();
    return (_jsx(Responsive, { minWidth: isCollapsedNav ? Sizes.lgMin : Sizes.xlgMin, children: _jsx(Separator, { children: _jsx(Tr, { children: _jsx(Td, { type: 'sub', bgColor: 'transparent' }) }) }) }));
};
export default TbodySeparator;
